export default __webpack_public_path__ + "static/IN-9008_Lenses_8mm_auto_15m_tag-2097fb633d9c2210771575e9df285057.webp";